export const socialsData = {
    github: 'https://github.com/cryptomehedi',
    facebook: 'https://www.facebook.com/itsmehedi.dev/',
    linkedIn: 'https://www.linkedin.com/in/itsmehedi-dev/',
    twitter: 'https://x.com/itsmehedi_dev',
    instagram: '#',

    mail: 'info@cryptomehedi.com',
}